import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '../prime-ng/prime-ng.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FooterComponent } from 'src/app/share-modul/components/layout/footer/footer.component';
import { LoginComponent } from 'src/app/share-modul/components/login/login.component';
import { PageNotFoundComponent } from 'src/app/share-modul/components/page-not-found/page-not-found.component';
import { HeaderComponent } from 'src/app/share-modul/components/layout/header/header.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { PosHeaderComponent } from 'src/app/share-modul/components/layout/pos-header/pos-header.component';
import { ChangeLanguageComponent } from 'src/app/share-modul/components/change-language/change-language.component';
import { SignupComponent } from "../../share-modul/components/signup/signup.component";
import { ResetPasswordComponent } from "../../share-modul/components/reset-password/reset-password.component";
import { ForgotPasswordComponent } from "../../share-modul/components/forgot-password/forgot-password.component";
import { ImageCropperModule } from "ngx-image-cropper";
import {
  CropAndCompressImageDialogComponent
} from "../../share-modul/components/crop-and-compress-image-dialog/crop-and-compress-image-dialog.component";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {
  ChangePasswordDialogComponent
} from "../../share-modul/components/change-password-dialog/change-password-dialog.component";
import { LoginWithRefreshTokenComponent } from 'src/app/share-modul/components/login-with-refresh-token/login-with-refresh-token.component';
import { WaiterHeaderComponent } from 'src/app/share-modul/components/layout/waiter-header/waiter-header.component';
import { SocAddonInputComponent } from '../../share-modul/components/uniform-components/soc-addon-input/soc-addon-input.component';
import { SocSearchInputComponent } from '../../share-modul/components/uniform-components/soc-search-input/soc-search-input.component';
import { SocTextFieldComponent } from '../../share-modul/components/uniform-components/soc-text-field/soc-text-field.component';
import { SocInputFieldComponent } from '../../share-modul/components/uniform-components/soc-input-field/soc-input-field.component';
import { SocConfirmationDialogComponent } from '../../share-modul/components/uniform-components/soc-confirmation-dialog/soc-confirmation-dialog.component';
import { SocAddonInputWithoutformComponent } from 'src/app/share-modul/components/uniform-components/soc-addon-input-withoutform/soc-addon-input-withoutform.component';
import { UnitShortenerPipe } from 'src/app/pos-panel/services/unit-shortener-pipe/unit-shortener.pipe';
import { TzConvertPipe } from 'src/app/share-modul/services/timezone-convert/tz-convert.pipe';

// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    FooterComponent,
    LoginComponent,
    LoginWithRefreshTokenComponent,
    PageNotFoundComponent,
    HeaderComponent,
    WaiterHeaderComponent,
    PosHeaderComponent,
    ChangeLanguageComponent,
    SignupComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    CropAndCompressImageDialogComponent,
    ChangePasswordDialogComponent,
    SocAddonInputComponent,
    SocSearchInputComponent,
    SocTextFieldComponent,
    SocInputFieldComponent,
    SocConfirmationDialogComponent,
    SocAddonInputWithoutformComponent,
    UnitShortenerPipe,
    TzConvertPipe
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    PrimeNgModule,
    CommonModule,
    NgbModule  ,
    ImageCropperModule,
    InfiniteScrollModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader
      }
    }),
  ],
  exports: [
    UnitShortenerPipe,
    TzConvertPipe,
    FooterComponent,
    LoginComponent,
    LoginWithRefreshTokenComponent,
    PageNotFoundComponent,
    HeaderComponent,
    WaiterHeaderComponent,
    PosHeaderComponent,
    ChangeLanguageComponent,
    ReactiveFormsModule,
    FormsModule,
    PrimeNgModule,
    NgbModule,
    TranslateModule,
    CommonModule,
    ImageCropperModule,
    InfiniteScrollModule,
    CropAndCompressImageDialogComponent,
    SocAddonInputComponent,
    SocSearchInputComponent,
    SocTextFieldComponent,
    SocInputFieldComponent,
    SocConfirmationDialogComponent,
    SocAddonInputWithoutformComponent
  ]
})
export class SharedModule {}
